export const COMPLAINT_UPDATE_NOTE = {
    REQUEST: 'COMPLAINT_SELLER.COMPLAINT_UPDATE_NOTE.REQUEST',
    SUCCESS: 'COMPLAINT_SELLER.COMPLAINT_UPDATE_NOTE.SUCCESS',
    FAILED: 'COMPLAINT_SELLER.COMPLAINT_UPDATE_NOTE.FAILED',
};

export const COMPLAINT_UPDATE_NOTE_CLEAR = "COMPLAINT_UPDATE_NOTE_CLEAR";